import template from './dashboard-enum-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController, IScope } from 'angular';
import type { EnumerationValue } from '../../../Shell/PandoraSolutionBuilderAgent/services/entity-service';

export class DashboardEnumFilterController implements IComponentController {
	filter!: InteractiveFilter;
	value?: string | null;
	selectedItems: Array<EnumerationValue> = [];
	initialized = false;
	isMultiStateGroups = false;

	static readonly $inject = ['$scope'];

	constructor(private readonly $scope: IScope) {}

	$onInit() {
		this.handleExternalChanges();

		this.$scope.$watchGroup(
			['vm.value', 'vm.selectedItems'],
			([value, selectedItems]: [value: string | undefined | null, selectedItems: EnumerationValue[] | undefined | null]) => {
				if ((selectedItems ?? []).length !== (value?.split(',') ?? []).length) {
					return;
				}

				if (Array.isArray(selectedItems) && selectedItems.length) {
					this.filter.setValue(
						selectedItems.map((item) => item.Value),
						this.filter.operators.In.getFullLabel(
							this.filter.title,
							selectedItems.map((item) => item.DisplayString)
						),
						this.filter.operators.In.getShortLabel(
							this.filter.title,
							selectedItems.map((item) => item.DisplayString)
						)
					);
				} else {
					this.filter.clear();
				}
			}
		);

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});

		if (this.filter.referenceFilter) {
			const matches = this.filter.referenceFilter.match(/StateGroup/gi);
			this.isMultiStateGroups = matches && matches.length >= 2 ? true : false;
		}

		this.initialized = true;
	}

	private handleExternalChanges() {
		this.value = this.filter.value?.join(',') ?? '';
		if (this.selectedItems.map((item) => item.Value).join(',') !== this.value) {
			this.selectedItems = [];
		}
	}
}

export const DashboardEnumFilterComponent = {
	name: 'mxDashboardEnumFilter',
	controller: DashboardEnumFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
